export const getRestaurantsList = async (searchText, restaurantName, token) => {
  let headers = {
    "Content-type": "application/json",
    "X-Consumer-Token": `${token}`
  };

  const url = new URL(
    "https://api.staging.diningclubgroup.com/restaurant-service-api/v3/restaurant"
  );
  url.searchParams.append("searchString", searchText);
  url.searchParams.append("restaurantName", restaurantName);

  try {
    const resp = await fetch(url.toString(), {
      method: "GET",
      headers: headers
    });
    const data = await resp.json();
    if (data) {
      return data;
    }
  } catch (e) {
    console.error(e);
    return e;
  }
};
